<script lang="ts" setup>
import { useFont } from '@/composables/font'
import { FONT_SIZE_STEP } from '@/constants/practiceConstants'

withDefaults(
  defineProps<{
    modelValue: number
    resetValue?: number
    showSlider?: boolean
  }>(),
  {
    resetValue: undefined,
    showSlider: true,
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

const { MAX_FONT_SIZE, MIN_FONT_SIZE } = useFont()
</script>

<template>
  <div class="d-flex align-center ga-1">
    <v-btn
      density="compact"
      :disabled="modelValue <= MIN_FONT_SIZE"
      icon
      size="small"
      variant="text"
      @click="emit('update:modelValue', Math.max(MIN_FONT_SIZE, modelValue - FONT_SIZE_STEP))"
    >
      <span class="font-size-btn">A<v-icon size="x-small">mdi-arrow-down</v-icon></span>
    </v-btn>
    <v-slider
      v-if="showSlider"
      color="primary"
      density="compact"
      hide-details
      :max="MAX_FONT_SIZE"
      :min="MIN_FONT_SIZE"
      :model-value="modelValue"
      :step="FONT_SIZE_STEP"
      style="min-width: 80px; max-width: 120px"
      thumb-label
      @dblclick="resetValue !== undefined && emit('update:modelValue', resetValue)"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <v-btn
      density="compact"
      :disabled="modelValue >= MAX_FONT_SIZE"
      icon
      size="small"
      variant="text"
      @click="emit('update:modelValue', Math.min(MAX_FONT_SIZE, modelValue + FONT_SIZE_STEP))"
    >
      <span class="font-size-btn-lg">A<v-icon size="x-small">mdi-arrow-up</v-icon></span>
    </v-btn>
  </div>
</template>

<style scoped>
.font-size-btn {
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.font-size-btn-lg {
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}
</style>
